import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Progress,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect, useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "../../Common/withRouter"

// users
import user4 from "../../../assets/images/users/avatar-4.jpg"
import { logoutUser, logoutUserFailed, setPayementInformation } from "../../../store/actions"
import { CustomToast } from "../../Lystface/Common/CustomToast"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import CustomPopup from "../../Common/CustomPopup"
import { billingContent } from "../../../pages/Dashboard/home/helper/ContentPopup"

const ProfileMenu = props => {
  const { userName, img: profileImage, card_setup, status, trialDtRem: trialDtRemFrmCnst, billing_setup } = useSelector(state => state.Login.constDetails)
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const stateAccountSetting = useSelector(state => state.Application?.getAccountData);
  const { logoutLoading, logoutErrorMessage } = useSelector(state => state.Login)
  const accountData = stateAccountSetting?.data || null
  const [profileIcon, setProfileIcon] = useState(null)
  const planSpecificaionState = useSelector(state => state.Home?.planSpecificationDetails?.plan)
  const { trial_act, status: planStatus, active, trial_dt_rem } = planSpecificaionState
  const trialDtRem = trial_dt_rem ? trial_dt_rem : trialDtRemFrmCnst
  const BillSetState = useSelector(state => state.BillSet)


  const dispatch = useDispatch();
  const history = useNavigate();




  useEffect(() => {
    if (logoutErrorMessage) {
      CustomToast({
        message: logoutErrorMessage,
        status: 'failure',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      dispatch(logoutUserFailed({ responseMessage: null }))
    }

  }, [logoutErrorMessage])


  const [username, setusername] = useState("Admin")

  useEffect(() => {
    if (accountData?.profile_deleted) {
      setProfileIcon(null)

    }
    else {
      let accountProfile = accountData?.profile_icon ? accountData?.profile_icon : accountData?.user_icon ? accountData?.user_icon : null
      let icon = accountProfile ? accountProfile : profileImage ? profileImage : null
      setProfileIcon(icon)
    }
    let name = accountData?.first_name
    if (name) setusername(name)
  }, [accountData, profileImage])



  useEffect(() => {
    console.log();
    setusername(userName)
  }, [userName])


  const handleLogout = () => {
    dispatch(logoutUser({ history: history }));

  }



  const onClickActiveTrial = () => {
    dispatch(setPayementInformation({ from: "payment-information" }))
    history('/settings/billing-details')
  }
  const onClickUpgrade = () => {
    history("/settings/pricing")
  }


  const totalDays = 14;
  const progress = ((totalDays - trialDtRem?.split("")[0]) / totalDays) * 100;
  const trial_active = trial_act !== null && trial_act !== undefined
  return (
    <React.Fragment>
      <div className="trail-container">
        {(planStatus ? planStatus?.length === 0 : status?.length === 0) ?
          <button className="header-trial-button" onClick={onClickActiveTrial}>Activate your free trial</button>
          :
          ((trial_active || planStatus) ? (trial_act && planStatus === "trialing") : status === "trialing") ?
            <div className="trial-progress">
              <span>{`Trial expiring in ${trialDtRem ? trialDtRem : "13 days"}`}</span>
              <div className="progress">
                <CircularProgressbar
                  value={progress === 0 ? 1 : progress}
                  styles={buildStyles({
                    pathColor: `#ffb72b`,
                    backgroundColor: "#ffff",
                    pathSize: 90, // Relative size of the path stroke
                    trailSize: 70, // Relative size of the trail stroke

                  })}
                />
              </div>

            </div>
            :
            (((trial_active && (active !== null && active !== undefined)) || planStatus === "cancelled") ? (trial_act === false && active === false || planStatus === "cancelled") : (status && status !== "active")) ?
              <div className="upgrade">Trial expired <span className="link" onClick={onClickUpgrade}>Upgrade now</span></div>
              :
              null
        }

      </div>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect pe-0"
          id="page-header-user-dropdown"
          tag="button"
          title={username}
        >
          {/* <img
            className="rounded-circle header-profile-user"
            src={user4}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{username}</span>{" "}
          <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i> */}
          {(profileIcon) ?
            <img className="header-profile-name" key={profileIcon} src={profileIcon} />
            :
            <span className="header-profile-name">{username?.charAt(0).toUpperCase()}</span>}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/*<DropdownItem tag="a" href="/profile">*/}
          {/*  {" "}*/}
          {/*  <i className="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>*/}
          {/*  {props.t("View Profile")}{" "}*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem tag="a" href="/">*/}
          {/*  <i className="uil uil-wallet font-size-18 align-middle me-1 text-muted"></i>*/}
          {/*  {props.t("My Wallet")}*/}
          {/*</DropdownItem>*/}
          <Link to="/settings/account-setting" className="dropdown-item">
            <i className="uil uil-cog font-size-18 align-middle me-1 text-muted"></i>
            <span>{props.t("Account settings")}</span>
          </Link>
          {/*<DropdownItem tag="a" href="auth-lock-screen">*/}
          {/*  <i className="uil uil-lock-alt font-size-18 align-middle me-1 text-muted"></i>*/}
          {/*  {props.t("Lock screen")}*/}
          {/*</DropdownItem>*/}
          <div className="dropdown-divider" />
          <Link className={`dropdown-item ${logoutLoading ? "disabled" : ""}`} onClick={handleLogout}>
            <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span className="logout">{props.t("Logout")}</span>
            {(logoutLoading) &&
              <div className="spinner-container spinner-border">
              </div>}          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
